import React, { useEffect } from 'react';
import * as CONSTANTS from '../../utils/CONSTANTS';
import { makeSideBarActive } from '../../utils/EllowUtils';
import ComingSoon from '../../components/comingSoon';
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import { useState } from 'react';
import Styles from "./styles.module.scss";
import BlacklistedTab from './blacklistedTab';
import { getAllocatedto, getCandidates } from '../resources/services';
import { viewedpageMixpanel } from '../../utils/mixpanel';


function Blacklisted() {
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2)
  const BreadcrumsValues = ["Blacklisted"]

  const [filterValues, setFilterValues] = useState<any>(null)
  const [companyName, setCompanyName] = useState<any>()
  const [blacklistedData, setBlacklistedData] = useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [total, setTotal] = useState<any>()
  const [sort, setSort] = useState<any>([]);

  useEffect(() => {
    
    getAllResources( 25, 1, '')
    getAllocation();
    viewedpageMixpanel();
  }, [])

  const getAllocation = () => {
    getAllocatedto().then((response: any) => {
      if (response && response.status === "success") {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        );
      }
    });
  };



  const getAllResources = ( pageSize: any, pageNumber: number, searchValue: string, filters?: any, sort?: any) => {
     

    getCandidates( 'blacklisted', pageSize, pageNumber, searchValue, filters, sort).then((response: any) => {
      if (response) {
        setBlacklistedData(response.data)
        setTotal(response.count)
     }

    })
  }

  const searchChange = (e: string) => {
    getAllResources( 25, 1, e, '', sort)
  }
  
  
  const closeTag = (data: any) => {
    let value = {
      filters: data
    }
      applyFilter(value);
    
  }

  const applyFilter = (data: any) => {
    setFilterValues(data.filters)
    getAllResources( 25, 1, '', data, sort)
  }

  const applySort = (sort: any) => {

    getAllResources( 25, 1, '', '', sort)

  }
  

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} openresource={'blacklisted'}/>
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          applyResourceFilter={applyFilter}
          searchChange={searchChange}
          closeTag={closeTag}
          navigateTo="../createResources"
          filterValues={filterValues}
          companyName={companyName}
          type='resources'
          allocatedTo={allocatedTo}
          
        />
      <section className="contentBox">
        <div className="innerPadd24">
          <BlacklistedTab data={blacklistedData} total={total} getTablesValues={() => getAllResources(25, 1, '')} setSort={setSort} applySort={applySort}
 />
        </div>
      </section>
      </div>
    </section>
  )
}

export default Blacklisted